import PbNotification from "./PbNotification";

export enum WebSocketPayloadType {
  LiveTrackingReading = "LIVE_TRACKING_READING",
  DeviceInformation = "DEVICE_INFORMATION", // TODO: Testing purposes for now.
  TerminatingLiveTrackingDueToLowBattery = "LOW_BATTERY_FINISH_LIVE_TRACKING",
  GeofenceEntered = "DEVICE_GEOFENCE_ENTERED",
  GeofenceExited = "DEVICE_GEOFENCE_EXITED",
}

export default interface WebhookNotification {
  type: WebSocketPayloadType;
  userId?: number;
  email?: string;
  data: PbNotification;
}

export const isWebhookNotification = (
    notification: any
  ): notification is WebhookNotification =>
    notification &&
    typeof notification === "object" &&
    Object.keys(notification).includes("type") &&
    typeof notification["type"] === "string" || WebSocketPayloadType &&
    Object.keys(notification).includes("data")
